import { gettext } from '@eventbrite/i18n';
export const SIZES_FROM_WIDGET = {
    xsmall: { icon: 'xsmall', ratingNumber: 'bs', reviewNumber: 'bs' },
    small: { icon: 'small', ratingNumber: 'bm', reviewNumber: 'bm' },
    medium: { icon: 'small', ratingNumber: 'bl', reviewNumber: 'bs' },
};

export const OPEN_MODAL_INFO = gettext('Display ratings info').toString();
